/* =========================================================
   Affiche GOLF « La partie » — la sortie à plusieurs.
   API : SNGolfPartie.render(data, opts) -> string SVG
     data : { parcours, lieu, date, titre, kicker, departs,
              j1..j6 (« Prénom|score|index »), format }
   Le meilleur score est détecté et mis en avant automatiquement.
   Auto-suffisant → re-render serveur direct pour l'impression.
   ========================================================= */
(function () {
  const PW = 800, PH = 1066, MX = 64;

  const PALETTES = {
    craie: { label:'Craie', bg:'#F7F4ED', ink:'#0B2D5B', muted:'#8B94A3', accent:'#FF6B2C', line:'#E3DDD0', card:'#FFFFFF', deep:'#DFE7DF' },
    green: { label:'Gazon', bg:'#0E3B2E', ink:'#F4F1E8', muted:'#8FB3A5', accent:'#FF6B2C', line:'#1C5544', card:'#134536', deep:'#0A2E23' },
    nuit:  { label:'Nuit',  bg:'#0B2D5B', ink:'#F7F4ED', muted:'#93A1B8', accent:'#FF9E5C', line:'#1E4272', card:'#12355F', deep:'#082444' },
    sable: { label:'Sable', bg:'#EDE3D2', ink:'#2C3A2E', muted:'#8A8676', accent:'#C4622D', line:'#DDD0B9', card:'#F7F1E6', deep:'#DCCFB6' },
  };

  const esc = s => String(s == null ? '' : s).replace(/&/g,'&amp;').replace(/</g,'&lt;').replace(/>/g,'&gt;');
  const up = s => String(s == null ? '' : s).toUpperCase();
  const num = s => { const m = String(s == null ? '' : s).match(/-?\d+/); return m ? parseInt(m[0], 10) : null; };
  const fit = (t, maxW, maxS, cwf, ls, minS) => { const n = String(t).length || 1; minS = minS || 12;
    for (let s = maxS; s > minS; s -= 1) if (n * (cwf * s + ls) <= maxW) return s; return minS; };
  const T = (x,y,size,fill,txt,o) => { o = o || {};
    return `<text x="${x}" y="${y}" font-family="${o.f||'Sora'}" font-size="${size}" font-weight="${o.w||600}" fill="${fill}"`
      + (o.ls?` letter-spacing="${o.ls}"`:'') + ` text-anchor="${o.a||'middle'}"` + `>${txt}</text>`; };

  /* Drapeau de liste : sans la coupe, qui ferait une tache sur une carte claire. */
  function flagListe(cx, baseY, h, p, col) {
    const top = baseY - h;
    return `<rect x="${cx-h*0.012}" y="${top}" width="${h*0.024}" height="${h}" rx="${h*0.012}" fill="${col}"/>`
      + `<path d="M${cx+h*0.012} ${top+h*0.02} L${cx+h*0.30} ${top+h*0.105} L${cx+h*0.012} ${top+h*0.19} Z" fill="${col}"/>`;
  }

  function render(data, opts) {
    data = data || {}; opts = opts || {};
    const p = PALETTES[opts.palette] || PALETTES.craie;
    const cx = PW / 2;

    const joueurs = [];
    for (let i = 1; i <= 6; i++) {
      const raw = String(data['j' + i] || '').trim(); if (!raw) continue;
      const [nom, score, idx] = raw.split('|').map(s => (s || '').trim());
      if (!nom) continue;
      joueurs.push({ nom, score, idx, n: num(score) });
    }
    const avecScore = joueurs.filter(j => j.n != null);
    const meilleur = avecScore.length ? Math.min.apply(null, avecScore.map(j => j.n)) : null;
    const vainqueur = avecScore.find(j => j.n === meilleur);

    const titre = up(data.titre) || 'LA PARTIE';
    const ts = fit(titre, 700, 74, 0.54, 2, 34);
    const sous = [up(data.parcours), up(data.departs)].filter(Boolean).join(' · ');

    let corps = '';
    if (joueurs.length) {
      const zone = 620, h = Math.min(106, Math.floor(zone / joueurs.length) - 16);
      const pas = h + 20;
      const y0 = 336 + Math.max(0, (zone - joueurs.length * pas) / 2);
      joueurs.forEach((j, i) => {
        const y = y0 + i * pas, gagne = meilleur != null && j.n === meilleur;
        corps += `<rect x="${MX}" y="${y-h/2}" width="${PW-2*MX}" height="${h}" rx="14" fill="${gagne?p.ink:p.card}" stroke="${gagne?p.ink:p.line}" stroke-width="1.5"/>`
          + flagListe(MX + 62, y + h*0.30, h*0.62, p, gagne ? p.accent : p.muted)
          + T(MX + 122, y - 2, Math.min(27, h*0.28), gagne?p.bg:p.ink, esc(up(j.nom)), { f:'Oswald', w:700, ls:1, a:'start' })
          + (j.idx ? T(MX + 122, y + 24, 13, p.muted, 'INDEX ' + esc(up(j.idx)), { w:600, ls:2, a:'start' }) : '')
          + `<text x="${PW-MX-28}" y="${y+18}" text-anchor="end" font-family="Oswald" font-weight="700" fill="${gagne?p.accent:p.ink}"><tspan font-size="${Math.min(56, h*0.56)}">${esc(j.score || '—')}</tspan></text>`;
      });
    }

    const cases = [[vainqueur ? vainqueur.nom : '', 'Vainqueur'], [meilleur != null ? String(meilleur) : '', 'Meilleur brut'], [joueurs.length ? String(joueurs.length) : '', 'Joueurs']]
      .filter(c => String(c[0] || '').trim());
    let barre = '';
    if (cases.length) {
      const x0 = 54, w = (PW - 2*x0) / cases.length, y = 1000;
      barre = `<line x1="${x0}" y1="${y-34}" x2="${PW-x0}" y2="${y-34}" stroke="${p.line}" stroke-width="1.5"/>`;
      cases.forEach((c, i) => {
        const cc = x0 + w*i + w/2;
        if (i) barre += `<line x1="${(x0+w*i).toFixed(0)}" y1="${y-14}" x2="${(x0+w*i).toFixed(0)}" y2="${y+30}" stroke="${p.line}" stroke-width="1.5"/>`;
        barre += T(cc, y+6, fit(c[0], w-24, 38, 0.56, 0, 18), p.ink, esc(c[0]), { f:'Oswald', w:700 })
          + T(cc, y+30, 12, p.muted, esc(up(c[1])), { w:600, ls:2.5 });
      });
    }

    return `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 ${PW} ${PH}" font-family="'Sora','Inter',sans-serif">
<rect width="${PW}" height="${PH}" fill="${p.bg}"/>
${T(cx, 84, 19, p.accent, esc(up(data.kicker) || up(data.date) || 'NOTRE PARTIE'), { w:700, ls:5 })}
${T(cx, 168, ts, p.ink, esc(titre), { f:'Oswald', w:700, ls:2 })}
${sous ? T(cx, 204, 17, p.muted, esc(sous), { w:600, ls:3.5 }) : ''}
${corps}
${barre}
</svg>`;
  }

  window.SNGolfPartie = { render, PALETTES };
})();
